export const THEME_PRESETS = {
  evergreen: { id: 'evergreen', name: 'Evergreen', description: 'Fresh green, calm and professional', primary: '#087f5b', deep: '#0b4d3a', soft: '#e7f5ef', accent: '#c9f1df' },
  ocean: { id: 'ocean', name: 'Ocean', description: 'Clear blue for focused daily operations', primary: '#0f7490', deep: '#164e63', soft: '#e0f5fa', accent: '#c5edf5' },
  indigo: { id: 'indigo', name: 'Indigo', description: 'Confident violet for modern teams', primary: '#4f46e5', deep: '#312e81', soft: '#ecebff', accent: '#ddd9ff' },
  ember: { id: 'ember', name: 'Ember', description: 'Warm orange for energetic retail', primary: '#c2410c', deep: '#7c2d12', soft: '#fff0e5', accent: '#fed7aa' },
  rose: { id: 'rose', name: 'Rose', description: 'Refined berry for distinctive brands', primary: '#be185d', deep: '#831843', soft: '#fce7f3', accent: '#fbcfe8' },
};

export function normalizeThemePreset(value) {
  return THEME_PRESETS[value] ? value : 'evergreen';
}

export function applyTenantTheme(value) {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.tenantTheme = normalizeThemePreset(value);
}
